import { useContext, useRef, useEffect } from "react";
import useFetch from "../hooks/useFetch";
import useTrackEvent from "../hooks/useTrackEvent";
import Button from "../components/Button";
import TextInput from "../components/TextInput";
import ImagePen from "../img/pen.png";
import ImageCheck from "../img/green-check.png";
import { useSwiper } from "swiper/react";
import SimulationContext from "../contexts/Simulation";

const RecapStep = () => {
  const swiper = useSwiper();
  const trackEvent = useTrackEvent();
  const [simParams] = useContext(SimulationContext);
  const inputFirstNameRef = useRef();
  const inputLastNameRef = useRef();
  const inputPhoneRef = useRef();
  const inputEmailRef = useRef();
  const inputCheckRef = useRef();
  const numberFormatter = Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
  const numberDecimalFormatter = Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });
  const [doGetSimu, responseGetSimu, isLoading, getSimuError] = useFetch(
    `${process.env.REACT_APP_API_URL}?action=adekwatts_send_simu`
  );

  const handleNext = () => {
    if (inputFirstNameRef.current.reportValidity() && 
        inputLastNameRef.current.reportValidity() && 
        inputPhoneRef.current.reportValidity() && 
        inputEmailRef.current.reportValidity() && 
        inputCheckRef.current.reportValidity() && 
        !isLoading)
    {
      document.getElementById('loader').classList.add('active');
      setTimeout(() => { 
        doGetSimu({
          method: 'POST',
          body: JSON.stringify({
            'simu': {
              'input': {
                'zip_code': simParams.location?.zip_code,
                'city': simParams.location?.name,
                'consos': simParams.consos,
                'daily_presence': simParams.infos?.daily_presence,
                'first_name': inputFirstNameRef.current.value,
                'last_name': inputLastNameRef.current.value,
                'email': inputEmailRef.current.value,
                'phone': inputPhoneRef.current.value,
              },
              'result': {
                'peak_power': simParams.simResults?.peak_power,
                'system_cost': numberFormatter.format(simParams.simResults?.system_cost),
                'battery': !simParams.infos?.daily_presence,
                'depreciation_period': simParams.simResults?.depreciation_period,
                'total_savings': numberFormatter.format(simParams.simResults?.total_savings),
                'yearly_roi': numberDecimalFormatter.format(simParams.simResults?.yearly_roi * 100)
              }
            }
          })
        });
      }, 2500);
    }
  }

  useEffect(() => {
    if (responseGetSimu)
    {
      trackEvent('simu_finish_submit', {
        'form_name': 'simulateur',
        'user_data': {
          'email_address': inputEmailRef.current.value || null,
          'phone_number': inputPhoneRef.current.value || null,
          'address': {
            'first_name': inputFirstNameRef.current.value || null,
            'last_name': inputLastNameRef.current.value || null,
            'postal_code': simParams.location?.zip_code || null
          }
        }
      });
      document.getElementById('loader').classList.remove('active');
      window.location.href = '/merci/?prev=simulateur';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseGetSimu]);

  useEffect(() => {
    if (getSimuError)
    {
      document.getElementById('loader').classList.remove('active');
      window.location.href = '/erreur/?prev=simulateur';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSimuError]);

  return (
    <div className="content recap">
      <h3 className="main">Votre étude solaire personnalisée est prête</h3>
      <div className="sub">Recevez votre estimation détaillée (production, économies, rentabilité) directement par email.</div>
      <TextInput 
        variant="recap" 
        readonly={true} 
        After={() => <img alt="" src={ImagePen} onClick={() => swiper.slideTo(1)}/>}
        value={`${simParams.location?.zip_code} ${simParams.location?.name}`}
      />
      <TextInput 
        variant="recap" 
        readonly={true} 
        After={() => <img alt="" src={ImagePen} onClick={() => swiper.slideTo(2)}/>}
        value={`${simParams.consos[0]} kWh - ${simParams.consos[1]} kWh - ${simParams.consos[2]} kWh`}
      />
      <TextInput 
        variant="recap" 
        readonly={true} 
        After={() => <img alt="" src={ImagePen} onClick={() => swiper.slideTo(3)}/>}
        value={simParams.infos?.daily_presence ? 'Oui' : 'Non'}
      />
      <h3 className="send">Envoyez mon étude gratuite</h3>
      <div className="send_form">
        <TextInput 
          variant="recap form" 
          readonly={false} 
          type="text"
          placeholder="Nom*"
          ref={inputLastNameRef}
          required={true}
        />
        <TextInput 
          variant="recap form" 
          readonly={false} 
          type="text"
          placeholder="Prénom*"
          ref={inputFirstNameRef}
          required={true}
        />
        <TextInput 
          variant="recap form" 
          readonly={false} 
          type="tel"
          placeholder="Téléphone*"
          pattern="0[0-9]{9}"
          ref={inputPhoneRef}
          required={true}
        />
        <TextInput 
          variant="recap form" 
          readonly={false} 
          type="email"
          placeholder="Email*"
          ref={inputEmailRef}
          required={true}
        />
      </div>
      <span className="consent"><input type="checkbox" required="required" ref={inputCheckRef} id="check-consent"/><label htmlFor="check-consent">En soumettant ce formulaire, j'accepte que ces informations soient utilisées par adekwatts pour me recontacter. Pour plus d'informations, veuillez prendre connaissance de notre politique de traitement des données personnelles.</label></span>
      <Button variant='yellow' onclick={handleNext}>Recevoir mon étude gratuite</Button>
      <ul className="reassu">
        <li><img alt="" src={ImageCheck}/>Etude gratuite et sans engagement</li>
        <li><img alt="" src={ImageCheck}/>Aucune revente de données</li>
        <li><img alt="" src={ImageCheck}/>Réponse sous 24h par un conseiller local</li>
      </ul>
    </div>
  )
}

export default RecapStep;